import { render, staticRenderFns } from "./LayoutTab.vue?vue&type=template&id=00ff503e&"
import script from "./LayoutTab.vue?vue&type=script&lang=js&"
export * from "./LayoutTab.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports